import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ResearchProjectsDetailsComponent } from './research-projects-details.component';
const routes: Routes = [
  {
    path: '',
    component: ResearchProjectsDetailsComponent
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ResearchProjectsDetailsRoutingModule { }